var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__account--system icon--style--fill icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20 23H4a2 2 0 01-2-2 5 5 0 015-5h10a5 5 0 015 5 2 2 0 01-2 2zM12 1C8.962 1 6.5 3.6 6.5 7.331S8.339 14.5 12 14.5s5.5-3.441 5.5-7.169S15.038 1 12 1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }